const initialState = {
    books: [],
    book: {}
};

export default initialState;
